<section>
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formFormat">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack()" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- Se comenta para evitar inconvenientes al eliminar formatos del sistema -->
              <!-- <div class="col-lg-6 col-md-4 col-sm-4 col-5 gap-1 d-flex justify-content-end">
              <app-custom-button [title]="'Eliminar'" [severity]="'danger'" [icon]="'pi pi-trash'"
                (onClick)="deleteFormat()"></app-custom-button>
              </div> -->

              <!-- Se comenta para evitar inconvenientes al crear formatos sin configuracion de html -->
              <!-- <app-custom-button [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              (onClick)="createFormat()"></app-custom-button> -->
            </div>
            <hr class="my-1">
          </div>
          <div class="row d-flex justify-content-between">
            <div class="row">
              <div class="col-lg-12">
                <div class="row py-md-2">
                  <div class="col field-company">
                    <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompany"
                      [required]="true" [recovery]="true" (onChangeSelect)="changeCompany($event)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="col field-code">
                    <app-custom-input-number formControlName="code" [labelText]="'Formato'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeCode()"></app-custom-input-number>
                  </div>
                  <div class="col field-name">
                    <app-custom-input-text formControlName="name" [labelText]="'Nombre Formato'"
                      [required]="true"></app-custom-input-text>
                  </div>
                  <div class="col field-head">
                    <app-custom-input-number formControlName="head" [labelText]="'Head'"
                      [required]="true"></app-custom-input-number>
                  </div>
                  <div class="col field-body">
                    <app-custom-input-number formControlName="body" [labelText]="'Body'"
                      [required]="true"></app-custom-input-number>
                  </div>
                  <div class="col field-foot">
                    <app-custom-input-number formControlName="foot" [labelText]="'Foot'"
                      [required]="true"></app-custom-input-number>
                  </div>
                  <div class="col field-paper-size">
                    <app-custom-select formControlName="paperSizeId" [labelText]="'Tamaño Papel'" [list]="listPaperSize"
                      [required]="true" (onChangeSelect)="changePaperSize($event)"></app-custom-select>
                  </div>
                  <div class="col field-checkbox d-flex align-items-end">
                    <app-custom-checkbox formControlName="group" [labelText]="'Agrupaciones'"></app-custom-checkbox>
                  </div>
                  <div class="col field-send d-flex justify-content-end align-items-end mt-2">
                    <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                      (onClick)="send()"></app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-format-detail [formatModel]="formatContract" [disabledDetail]="disabledDetail"
      [updateListDetail]="updateListDetail" [companyId]="companyIdForDetail" (updateList)="getUpdateListDetail()"
      (emitQuantityDetails)="getQuantityDetails($event)">
    </app-format-detail>
  </div>
</section>